(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofermas-home"] && !Shopify.designMode) return;
  try {
    
function initOfermasHome(root){const home=root.querySelector('.of-hero');if(!home||home.dataset.ready)return;home.dataset.ready='true';if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('of-enter');observer.unobserve(entry.target);}}),{threshold:.08});home.parentElement.querySelectorAll('.of-section-heading,.of-card,.of-category,.of-steps article').forEach(item=>observer.observe(item));}
initOfermasHome(document);document.addEventListener('shopify:section:load',event=>initOfermasHome(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofermas-product"] && !Shopify.designMode) return;
  try {
    
function setupOfermasProduct(root) {
const page = root.querySelector('[data-of-product]');
if (!page || page.dataset.ready) return;
page.dataset.ready='true';
page.querySelectorAll('[data-of-image]').forEach(button => button.addEventListener('click', () => {
const image = page.querySelector('.of-product-image');
image.src = button.dataset.ofImage;
image.srcset='';
image.alt=button.dataset.ofAlt;
page.querySelector('[data-of-zoom]').href=button.dataset.ofLarge;
page.querySelectorAll('[data-of-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
}));
page.querySelector('[data-of-variant]')?.addEventListener('change', event => {
const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);window.location.assign(url);
});
const order=page.querySelector('#of-order'),sticky=page.querySelector('[data-of-sticky]');
let queued = false;
const controller = new AbortController();
function updateSticky(){queued=false;const visible=order.getBoundingClientRect().bottom < 125;sticky.classList.toggle('is-visible',visible);sticky.inert=!visible;}
function scheduleSticky(){if(!queued){queued=true;requestAnimationFrame(updateSticky);}}
window.addEventListener('scroll',scheduleSticky,{passive:true,signal:controller.signal});
window.addEventListener('resize',scheduleSticky,{passive:true,signal:controller.signal});
document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(page))controller.abort();},{signal:controller.signal});
updateSticky();
}
setupOfermasProduct(document);
document.addEventListener('shopify:section:load',event=>setupOfermasProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ofertnda-market"] && !Shopify.designMode) return;
  try {
    
function initOfertnda(root) {
const page = root.querySelector('.om');
if (!page || page.dataset.initialized) return;
page.dataset.initialized = 'true';
const slides = page.querySelectorAll('[data-om-slide]');
const dots = page.querySelectorAll('[data-om-dot]');
let active = 0;
function show(index) { active = (index + slides.length) % slides.length; slides.forEach((slide,i) => slide.hidden = i !== active); dots.forEach((dot,i) => dot.setAttribute('aria-pressed', String(i === active))); }
page.querySelectorAll('[data-om-step]').forEach(button => button.addEventListener('click', () => show(active + Number(button.dataset.omStep))));
dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.omDot))));
if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('om-reveal'); observer.unobserve(entry.target); } }), {threshold:.08});
page.querySelectorAll('.om-section,.om-feature,.om-news-card').forEach(item => observer.observe(item));
}
}
initOfertnda(document);
document.addEventListener('shopify:section:load', event => initOfertnda(event.target));

  } catch(e) { console.error(e); }
})();
})();
